import { render } from "./Calendars.vue?vue&type=template&id=f22d9cd2&scoped=true"
import script from "./Calendars.vue?vue&type=script&lang=js"
export * from "./Calendars.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-f22d9cd2"

export default script